const initState = {
    tablero_Data: null,
    tablero_Error: null,
    tablero_Loading: false,
    tablero_Detalle: null,
    tablero_Detalle_Error: null,
    tablero_Detalle_Loading: false,
    tablero_GuiasReparto: null,
    tablero_GuiasReparto_Error: null,
    tablero_GuiasReparto_Loading: false,
    tablero_GuiasEficiencia: null,
    tablero_GuiasEficiencia_Error: null,
    tablero_GuiasEficiencia_Loading: false,
    tablero_Eficiencia: null,
    tablero_Eficiencia_Error: null,
    tablero_Eficiencia_Loading: false,
    tablero_GuiaDetalles: null,
    tablero_GuiaDetalles_Error: null,
    tablero_GuiaDetalles_Loading: false
}

const tableroControlReducer = (state = initState, action) => {
    switch (action.type) {
        case "TABLERO_LOADING":
            return {
                ...state,
                tablero_Loading: true,
                tablero_Error: null
            }
        case "TABLERO_RESUMEN_SUCCESS":
            return {
                ...state,
                tablero_Data: action.payload.data,
                tablero_Loading: false,
                tablero_Error: null
            }
        case "TABLERO_RESUMEN_ERROR":
            return {
                ...state,
                tablero_Error: action.payload.error,
                tablero_Data: null,
                tablero_Loading: false
            }
        case "TABLERO_DETALLE_LOADING":
            return {
                ...state,
                tablero_Detalle: null,
                tablero_Detalle_Loading: true,
                tablero_Detalle_Error: null
            }
        case "TABLERO_DETALLE_SUCCESS":
            return {
                ...state,
                tablero_Detalle: action.payload.data,
                tablero_Detalle_Loading: false,
                tablero_Detalle_Error: null
            }
        case "TABLERO_DETALLE_ERROR":
            return {
                ...state,
                tablero_Detalle_Error: action.payload.error,
                tablero_Detalle: null,
                tablero_Detalle_Loading: false
            }
        case "TABLERO_DETALLE_LIMPIAR":
            return {
                ...state,
                tablero_Detalle: null,
                tablero_Detalle_Error: null,
                tablero_Detalle_Loading: false
            }
        case "TABLERO_GUIAS_REPARTO_LOADING":
            return {
                ...state,
                tablero_GuiasReparto_Loading: true,
                tablero_GuiasReparto_Error: null
            }
        case "TABLERO_GUIAS_REPARTO_SUCCESS":
            return {
                ...state,
                tablero_GuiasReparto: action.payload.data,
                tablero_GuiasReparto_Loading: false,
                tablero_GuiasReparto_Error: null
            }
        case "TABLERO_GUIAS_REPARTO_ERROR":
            return {
                ...state,
                tablero_GuiasReparto_Error: action.payload.error,
                tablero_GuiasReparto: null,
                tablero_GuiasReparto_Loading: false
            }
        case "TABLERO_GUIAS_REPARTO_LIMPIAR":
            return {
                ...state,
                tablero_GuiasReparto: null,
                tablero_GuiasReparto_Error: null,
                tablero_GuiasReparto_Loading: false
            }
        case "TABLERO_GUIAS_EFICIENCIA_LOADING":
            return {
                ...state,
                tablero_GuiasEficiencia_Loading: true,
                tablero_GuiasEficiencia_Error: null
            }
        case "TABLERO_GUIAS_EFICIENCIA_SUCCESS":
            return {
                ...state,
                tablero_GuiasEficiencia: action.payload.data,
                tablero_GuiasEficiencia_Loading: false,
                tablero_GuiasEficiencia_Error: null
            }
        case "TABLERO_GUIAS_EFICIENCIA_ERROR":
            return {
                ...state,
                tablero_GuiasEficiencia_Error: action.payload.error,
                tablero_GuiasEficiencia: null,
                tablero_GuiasEficiencia_Loading: false
            }
        case "TABLERO_GUIAS_EFICIENCIA_LIMPIAR":
            return {
                ...state,
                tablero_GuiasEficiencia: null,
                tablero_GuiasEficiencia_Error: null,
                tablero_GuiasEficiencia_Loading: false
            }
        case "TABLERO_GUIA_DETALLES_LOADING":
            return {
                ...state,
                tablero_GuiaDetalles_Loading: true,
                tablero_GuiaDetalles_Error: null
            }
        case "TABLERO_GUIA_DETALLES_SUCCESS":
            return {
                ...state,
                tablero_GuiaDetalles: action.payload.data,
                tablero_GuiaDetalles_Loading: false,
                tablero_GuiaDetalles_Error: null
            }
        case "TABLERO_GUIA_DETALLES_ERROR":
            return {
                ...state,
                tablero_GuiaDetalles_Error: action.payload.error,
                tablero_GuiaDetalles: null,
                tablero_GuiaDetalles_Loading: false
            }
        case "TABLERO_GUIA_DETALLES_LIMPIAR":
            return {
                ...state,
                tablero_GuiaDetalles: null,
                tablero_GuiaDetalles_Error: null,
                tablero_GuiaDetalles_Loading: false
            }
        case "TABLERO_EFICIENCIA_LOADING":
            return {
                ...state,
                tablero_Eficiencia_Loading: true,
                tablero_Eficiencia_Error: null
            }
        case "TABLERO_EFICIENCIA_SUCCESS":
            return {
                ...state,
                tablero_Eficiencia: action.payload.data,
                tablero_Eficiencia_Loading: false,
                tablero_Eficiencia_Error: null
            }
        case "TABLERO_EFICIENCIA_ERROR":
            return {
                ...state,
                tablero_Eficiencia_Error: action.payload.error,
                tablero_Eficiencia: null,
                tablero_Eficiencia_Loading: false
            }
        default:
            return state;
    }
}

export default tableroControlReducer;
